import { normalizeGetImage } from 'my-purchases/hooks/useArticleImage/normalization'
import type { OrderLineWithFormattedPrices } from 'my-purchases/types/purchaseCommon'
import type { Article } from 'my-purchases/types/purchaseList'
import { type Product } from 'product/types'

export const normalizeData = ({
	product,
	articleItem,
}: {
	product: Product
	articleItem: OrderLineWithFormattedPrices
}): Article | null => {
	const {
		sizeId,
		colorId,
		originalPriceAmountConverted,
		paidPriceAmountConverted,
		...articleItemRest
	} = articleItem

	const { name, reference, url } = product

	const { imageToShow, color, size } = normalizeGetImage({
		product,
		colorId,
		sizeId,
	})

	return {
		...articleItemRest,
		name,
		sizeId,
		reference,
		colorId,
		image: imageToShow,
		color: {
			colorId,
			colorBulletImg: color?.bulletImg,
			colorLabel: color?.label,
		},
		size: size?.label ?? '',
		prices: {
			originalPrice: originalPriceAmountConverted,
			...(originalPriceAmountConverted.price !==
				paidPriceAmountConverted.price && {
				discountedPrice: paidPriceAmountConverted,
			}),
		},
		...(url && { url: colorId ? `${url}?c=${colorId}` : url }),
	}
}

export const normalizeDefaultArticle = ({
	articleItem,
}: {
	articleItem: OrderLineWithFormattedPrices
}): Article => {
	const {
		id,
		colorId,
		originalPriceAmountConverted,
		paidPriceAmountConverted,
		...articleItemRest
	} = articleItem

	return {
		...articleItemRest,
		id,
		colorId,
		name: '',
		size: '',
		reference: id,
		image: null,
		color: {
			colorId,
		},
		prices: {
			originalPrice: originalPriceAmountConverted,
			...(originalPriceAmountConverted.price !==
				paidPriceAmountConverted.price && {
				discountedPrice: paidPriceAmountConverted,
			}),
		},
	}
}
